module.exports = __webpack_public_path__ + "img/intro_bg.8950dbe9.jpg";